import { useApplies, type UseAppliesParams } from "./useApplies";

export type UseAppliesCountParams = Omit<UseAppliesParams, "page" | "pageSize" | "sortColumn" | "sortDirection">;

export function useAppliesCount(params: UseAppliesCountParams): { count: number; isLoading: boolean } {
  const { data, isFetching } = useApplies({ ...params, page: 1, pageSize: 1 });
  return { count: data?.totalRecords ?? 0, isLoading: isFetching };
}
